import React from "react";
import { Field } from "formik";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";
import Select from "components/Form/Select";

const GeneralForm = ({ groups, getGroupLabel }) => (
	<div>
		<Field type="text" name="label" customlabel="Motif" component={CustomInputTextComponent} required />
		<Field type="number" name="order" customlabel="Ordre" component={CustomInputTextComponent} required />
		<Field
			component={Select}
			name="group"
			customlabel="Groupe"
			placeholder="Sélectionner un groupe"
			options={groups.map((group) => {
				return {
					value: group,
					label: getGroupLabel(group),
				};
			})}
			required
		/>
	</div>
);

export default GeneralForm;
